import React, { Fragment, useState } from "react";
import opendota from "../../apis";
import Modal from "../utilities/Modal";
import MatchSummary from "../account/match/MatchSummary";
import { IoMdSearch } from "react-icons/io";
import Loader from "../utilities/Loader";

const SearchMatch = () => {
  const [matchID, setMatchID] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [hideMtchSmry, setHideMtchSmry] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const [slctdMtchData, setSlctdMtchData] = useState([]);

  const openMtchSmry = (match) => {
    setSlctdMtchData(match);
    setHideMtchSmry(false);
  };
  const closeModal = () => {
    setMatchID("");
    setHideMtchSmry(true);
  };

  const trgrSearch = async () => {
    console.log("sfd");
    setShowLoader(true);
    setErrorMsg("");
    let response = null;
    try {
      response = await opendota.get(`matches/${matchID}`);
      if (response.data !== undefined) {
        openMtchSmry(response.data);
      } else {
        setErrorMsg("No Match Found");
      }
    } catch (e) {
      setErrorMsg("No Match Found");
    }
    setShowLoader(false);
  };

  if (hideMtchSmry !== true) {
    return (
      <Modal closeModal={closeModal} modalName="Match Summary">
        <MatchSummary match={slctdMtchData} />
      </Modal>
    );
  } else {
    return (
      <Fragment>
        {showLoader && <Loader />}
        <div className="d-flex justify-content-between position-relative flex-column">
          <div
            className="input-group align-items-center gap-2"
            style={{
              border: "3px solid rgba(255,255,255,0.6)",
              borderRadius: "8px",
              padding: "10px 25px",
            }}
          >
            <IoMdSearch size={"25px"} />
            <input
              type="text"
              className="form-control search-Input border-0 shadow-none"
              placeholder="Enter Match ID"
              value={matchID}
              onChange={(e) => {
                setMatchID(e.target.value);
              }}
            />
            <button
              className="btn btn-default text-light bg-dark"
              type="submit"
              style={{
                borderRadius: "8px",
                padding: "10px",
              }}
              onClick={trgrSearch}
            >
              SEARCH
            </button>
          </div>
          {errorMsg !== "" && (
            <div className="no-account-found">{errorMsg}</div>
          )}
          {/* <SearchValue placeholder={value} trgrSearch={trgrSearch} /> */}
        </div>
      </Fragment>
    );
  }
};

export default SearchMatch;
